import React, { useState, useRef } from "react";
import { Box, CssBaseline, Grid } from "@mui/material";
import { Button, TextField, Typography } from "@mui/material";
import logoImage from "../../../assets/images/logoblue.png";
import { useAuth } from "../../../hooks";

function DigitCodeLogin() {
  const { onLogin } = useAuth();
  const [codes, setCodes] = useState(["", "", "", "", "", ""]);
  const inputRefs = [
    useRef(),
    useRef(),
    useRef(),
    useRef(),
    useRef(),
    useRef(),
  ];

  const handleCodeChange = (index, value) => {
    const newCodes = [...codes];
    newCodes[index] = value;
    setCodes(newCodes);

    // Move focus to the next input field if available
    if (value && index < 5) {
      inputRefs[index + 1].current.focus();
    }

    // Move focus to the previous input field if available
    if (!value && index > 0) {
      inputRefs[index - 1].current.focus();
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    onLogin();
    // Perform action on form submission, e.g., validate code
    const code = codes.join("");
    console.log("Code:", code);
  };

  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <CssBaseline />
        <Grid
          container
          direction="column"
          alignItems="center"
          spacing={2}
          maxWidth="370px"
        >
          <Grid item>
            <img
              src={logoImage}
              alt="Logo"
              style={{ width: "335.99px", height: "86px", color: "#00A7CD" }}
            />
          </Grid>

          <Grid
            item
            display={"flex"}
            flexDirection="column"
            gap={"4px"}
            spacing={2}
            width="100%"
          >
            <Typography
              style={{ textAlign: "center", fontSize: "18px", fontWeight: 700 }}
            >
              Enter Code
            </Typography>
            <Typography
              item
              style={{
                textAlign: "center",
                fontSize: "12px",
                fontWeight: 400,
                lineHeight: "17px",
              }}
            >
              Please enter the code that was sent to your e-mail address
            </Typography>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                gap: "5px",
                paddingTop: "10px",
              }}
            >
              {codes.map((code, index) => (
                <TextField
                  key={index}
                  inputRef={inputRefs[index]}
                  type="text"
                  value={code}
                  onChange={(e) => handleCodeChange(index, e.target.value)}
                  variant="outlined"
                  inputProps={{
                    maxLength: 1,
                    style: {
                      textAlign: "center",
                      width: "45px",
                      height: "40px",
                      borderRadius: "8px",
                      border: "2px solid #00A7CD",
                      fontSize: "48px",
                      fontWeight: 500,
                      lineHeight: "20px",
                      letterSpacing: "-0.15px",
                    },
                  }}
                />
              ))}
            </div>
          </Grid>

          <Grid item width="363px">
            <Button
              variant="contained"
              color="primary"
              onClick={handleSubmit}
              style={{
                width: "100%",
                height: "34px",
                borderRadius: "4px",
                backgroundColor: "#00A7CD",
              }}
            >
              Login
            </Button>
          </Grid>
          <Grid item width={"336px"}>
            <Typography
              variant="body2"
              textAlign={"center"}
              fontSize={15}
              fontWeight={700}
            >
              <a
                href="#"
                style={{
                  textDecoration: "none",
                  borderBottom: "none",
                  color: "#49BED9 ",
                }}
              >
                Re-send code
              </a>
            </Typography>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}

export default DigitCodeLogin;
